<template>
  <el-card style="min-height: 480px">
    <span slot="header">安全和权限</span>
    <el-form :model="form" status-icon :rules="rules" ref="form" size="small">
      <el-form-item label="旧密码" prop="old">
        <el-input
          type="password"
          v-model="form.old"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newest">
        <el-input
          type="password"
          v-model="form.newest"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input
          type="password"
          v-model="form.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit('form')">
          保存新密码
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import { personUpdatePwd } from '@/api/person.js'
export default {
  name: 'ProfilePassword',
  props: {
    /**
     * 用户id
     */
    personId: {
      type: Number,
      required: true,
    },
  },
  data() {
    var conformValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newest) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        old: '',
        newest: '',
        checkPass: '',
      },
      rules: {
        old: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
        newest: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
        checkPass: [{ validator: conformValidator, trigger: 'blur' }],
      },
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          personUpdatePwd(this.personId, this.form).then((data) => {
            if (data.code === 20000) {
              this.$message.success(data.message)
            } else {
              this.$message.error(data.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/_profile/Password.vue